import * as yup from 'yup';

const productTypeValidator = yup.object({
  name: yup.string().required('Szükséges mező'),
  description: yup.string().required('Szükséges mező')
});

export default productTypeValidator;
